<div class="alert alert-danger alert-dismissible fade show text-center" role="alert"
    *ngIf="!loading && currentStudio && currentStudio.is_partner && currentStudio.promo_code_text != null && currentStudio.promo_code_text != '' && currentStudio.promo_code_text != 'null' && currentStudio.promo_code_text != undefined">
    <span class="alert-inner--icon"><i class="ni ni-tag"></i></span>
    <span class="alert-inner--text"> Obtenez votre réduction de <strong>{{ currentStudio.promo_code_value }}</strong> en
        appliquant le code <strong>{{ currentStudio.promo_code_text }}</strong></span>
</div>
<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!loading && currentStudio && currentStudio.is_partner">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center">
            <div class="h2 text-uppercase">Prix de la session</div>
            <div>
                <div class="text-danger h2 font-weight-bolder">{{currentStudio.price}} € / HEURE
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="form-group pt-3">
            <strong>📅 Sélectionnez un créneau souhaité</strong>
            <p>
                (La réservation est soumise à confirmation par le studio.)
            </p>
            <label for="startDate">Date souhaitée</label>
            <div class="input-group m-0">
                <input id="startDate" class="form-control m-0" placeholder="jj/mm/aaaa"
                    formControlName="startDateMockup" [minDate]="toDay" ngbDatepicker #d1="ngbDatepicker"
                    [dayTemplate]="customDay">
                <div class="input-group-append">
                    <button class="btn button-radius-right btn-studiomap" (click)="d1.toggle(); dropdownOpen = false"
                        type="button"><i class="fas fa-calendar-alt"></i>
                    </button>
                </div>
            </div>
            <!-- errors -->
            <div class="text-danger" *ngIf="form.get('startDate')?.hasError('required') && submitted">
                Veuillez sélectionner une date
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="form-group">
            <label for="startHour">Heure souhaitée</label>
            <div class="dropdown w-100 position-relative">
                <button class="form-control text-start d-flex justify-content-between align-items-center" type="button"
                    [ngClass]="{'border-danger': formControl.startTime.errors && submitted}" (click)="toggleDropdown()">
                    <span>
                        {{ form.value.startTime }}
                    </span>
                    <div class="">
                        <span *ngIf="getDiscountRateForHour(form.value.startTime)"
                            class="badge bg-studiomap rounded-pill text-white mr-2">
                            - {{ getDiscountRateForHour(form.value.startTime) }}%
                        </span>
                        <i class="fa fa-chevron-down"></i>
                    </div>
                </button>

                <ul *ngIf="dropdownOpen" class="dropdown-menu show w-100 shadow-sm mt-1"
                    style="max-height: 250px; overflow-y: auto;">
                    <li class="dropdown-item d-flex justify-content-between align-items-center"
                        *ngFor="let hour of hours" (click)="selectHour(hour)"
                        [class.active]="selectedHour?.value === hour.value" style="cursor: pointer;">
                        {{ hour }}
                        <span *ngIf="getDiscountRateForHour(hour)"
                            class="badge bg-studiomap rounded-pill text-white ms-2">
                            - {{ getDiscountRateForHour(hour) }}%
                        </span>
                    </li>
                </ul>
            </div>

            <!-- errors -->
            <div class="text-danger" *ngIf="form.get('startTime')?.hasError('required') && submitted">
                Veuillez sélectionner une heure
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="form-group">
            <label for="numberOfHours">Durée estimée</label>
            <input [ngClass]="{'border-danger':formControl.nbr_hours.errors && submitted}" formControlName="nbr_hours"
                type="number" class="form-control" id="numberOfHours" [attr.min]="currentStudio?.nbr_min_hours" max="23"
                step="1">
            <!-- erros -->
            <div class="text-danger" *ngIf="form.get('nbr_hours')?.hasError('max') && submitted">
                Le Nombre d'heures maximal est 23H.
            </div>
            <div class="text-danger" *ngIf="form.get('nbr_hours')?.hasError('min') && submitted">
                Le Nombre d'heures minimal est {{currentStudio?.nbr_min_hours}}H.
            </div>
            <div class="text-danger" *ngIf="form.get('nbr_hours')?.hasError('required') && submitted">
                Veuillez sélectionner un nombre d'heures valide
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="form-group">
            <label for="promoCode">Code promotionnel</label>
            <div class="input-group mb-1" *ngIf="!promo_code_is_valid">
                <input formControlName="promo_code" type="text" class="form-control" id="promoCode"
                    placeholder="Entrez le code promotionnel">
                <div class="input-group-append">
                    <button class="btn btn-secondary" type="button" *ngIf="checking_promo_code"><i
                            class="fa fa-spinner fa-spin" style="font-size:24px"></i></button>

                    <button class="btn btn-studiomap" type="button" (click)="check_promo_code()"
                        *ngIf="!checking_promo_code">Valider</button>
                </div>
            </div>
            <div class="input-group mb-1" *ngIf="promo_code_is_valid">
                <input formControlName="promo_code" type="text" class="form-control" id="promoCode"
                    placeholder="Entrez le code promotionnel" readonly>
                <div class="input-group-append">
                    <button class="btn btn-studiomap" type="button" (click)="dettach_promo_code()">X</button>
                </div>
            </div>
            <small class="form-text text-danger" *ngIf="promo_code_error != ''">{{ promo_code_error }}</small>
        </div>
    </div>
    <div class="col-md-12 mb-2">
        <h4 class="d-flex justify-content-between"><strong>Date de début :</strong> {{ selectedStartDate }}</h4>
        <h4 class="d-flex justify-content-between"><strong>Date de fin : </strong>{{ selectedEndDate }}</h4>
    </div>

    <div class="col-md-12 d-flex align-items-center">
        <div class="w-100 my-3">
            <p>⚠️ Votre demande de réservation sera transmise au studio. Celui-ci vous contactera pour confirmer le
                créneau exact ou proposer une alternative en fonction des disponibilités.</p>
            <strong>🔴 RÉSERVER (SOUS RÉSERVE DE DISPONIBILITÉ)</strong>
        </div>
    </div>

    <div class="col-md-12 d-flex align-items-center">
        <div class="w-100 text-center my-3">
            <button class="btn btn-studiomap mb-2 w-100" type="submit">RÉSERVER</button>
        </div>
    </div>
    <div class="col-md-12 mb-2">
        <h4 class="d-flex justify-content-between"><strong>{{currentStudio?.price}}€ x
                {{form.get("nbr_hours")?.value}} heures : </strong>{{(form.get('startDate')?.value) ?
            currentStudio.price * form.get("nbr_hours")?.value : "---" }} €</h4>
        <h4 class="d-flex justify-content-between"><strong>Frais fixes : </strong>{{(form.get('startDate')?.value) ?
            price_fees?.fc : "---" }} €</h4>
        <h4 class="d-flex justify-content-between"><strong>Frais variables :
            </strong>{{(form.get('startDate')?.value) ? price_fees?.vc : "---" }} %</h4>
        <h4 class="d-flex justify-content-between"><strong>TVA : </strong>{{(form.get('startDate')?.value) ?
            price_fees?.tva : "---" }} %</h4>
        <hr class="my-2">
        <h4 class="d-flex justify-content-between">
            <strong>Total : </strong>
            <span *ngIf="!promo_code_is_valid && !discount_periods_found"><strong>{{ (form.get('startDate')?.value) ? final_price : "---" }}
                    €</strong></span>
            <span *ngIf="promo_code_is_valid || discount_periods_found"><del><strong>{{ (form.get('startDate')?.value) ? final_price : "---" }}
                        €</strong></del></span>
        </h4>

        <h4 class="d-flex justify-content-between" *ngIf="promo_code_is_valid || discount_periods_found">
            <strong>Réduction : </strong><span><strong class="text-danger">-{{ reduce_value }} €</strong></span>
        </h4>
        <h4 class="d-flex justify-content-between" *ngIf="promo_code_is_valid || discount_periods_found">
            <strong>Montant à payer : </strong><strong>{{ final_price_after_apply_promo }} €</strong>
        </h4>
    </div>
</form>
<div *ngIf="!loading && !currentStudio">
    <p class="text-center">Le studio n'est pas disponible pour le moment.<br>
        <a href="javascript:void(0)" (click)="navigateTo('contact')"> Veuillez contacter notre support</a>
    </p>
</div>
<div *ngIf="!loading && currentStudio && !currentStudio.is_partner">
    <p class="text-center">Ce studio n'est pas partenaire.<br>
        <a href="javascript:void(0)" (click)="navigateTo('contact')"> Veuillez contacter notre support</a>
    </p>
</div>

<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
    let-focused="focused">
    <div class="custom-day-wrapper" [class.hidden]="date.month !== currentMonth">
        <span class="custom-day" [class.weekend]="isDiscountDay(date)" [class.focused]="focused"
            [class.bg-studiomap]="selected" [class.text-muted]="disabled">
            {{ date.day }}
        </span>
        <div *ngIf="isDiscountDay(date)" class="percent-icon">%</div>
    </div>
</ng-template>